export const NoDataMessage = () => (
  <div className="card-board p-8 text-center">
    <h1 className="heading-display text-xl mb-2">Averages</h1>
    <p className="text-brand-muted">No book averages posted yet.</p>
    <p className="text-sm text-brand-muted mt-2">
      Averages show here once they are entered for this tournament.
    </p>
  </div>
);
